import { render, staticRenderFns } from "./SettingsGroupModal.vue?vue&type=template&id=3d2e3bea&scoped=true&"
import script from "./SettingsGroupModal.vue?vue&type=script&lang=js&"
export * from "./SettingsGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGroupModal.vue?vue&type=style&index=0&id=3d2e3bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e3bea",
  null
  
)

export default component.exports